<template>
  <div :class="$style['pt-third-vendor-form']">
      <pt-sub-title title="供应商基本信息"></pt-sub-title>
      <pt-form-item label="供应商名称：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.name" data-vv-as="供应商名称" v-validate="'required'" v-model="vendorData.base.name" placeholder="请输入供应商名称"></el-input>
      </pt-form-item>
      <pt-form-item label="类型：" :labelWidth="labelWidth">
        <vendor-type-selector v-model="vendorData.base.type"></vendor-type-selector>
      </pt-form-item>
      <pt-form-item label="联系人：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.contact" data-vv-as="联系人" v-validate="'required'" v-model="vendorData.base.contact" placeholder="请输入联系人姓名"></el-input>
      </pt-form-item>
      <pt-form-item label="手机号：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.mobile" data-vv-as="手机号" v-validate="'required'" v-model="vendorData.base.mobile" placeholder="请输入手机号"></el-input>
      </pt-form-item>
      <pt-form-item label="邮箱：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.email" data-vv-as="邮箱" v-validate="'required'" v-model="vendorData.base.email" placeholder="请输入邮箱"></el-input>
      </pt-form-item>
      <pt-sub-title title="供应商企业基本信息"></pt-sub-title>
      <pt-form-item label="社会统一信用代码：" :labelWidth="labelWidth" :required="true">
        <el-input name="base.secCode" data-vv-as="社会统一信用代码" v-validate="'required'" v-model="vendorData.base.secCode" placeholder="请输入社会统一信用代码"></el-input>
      </pt-form-item>
      <pt-form-item label="营业执照副本：" :labelWidth="labelWidth" :required="true">
        <!-- <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text"
          v-model="vendorData.base.licenses" :class="$style['dialog-upload']">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file> -->
        <wt-upload-big-file v-model="vendorData.base.licenses" @getStatus="getStatus"></wt-upload-big-file>
      </pt-form-item>
      <pt-form-item label="其他资质证照：" :labelWidth="labelWidth">
        <wt-upload-file :action="uploadApi" :data="picture_params" path-url-name="url" :img-url="privateResourcesUrl"
          v-model="vendorData.base.qualifications" :multiple="true" :class="$style['upload-picture']">
            <div :class="$style['upload-file-text']" class="main-color" @click.stop.prevent="showDialog = true">+添加图片</div>
        </wt-upload-file>
        <ul :class="$style.pictureNames">
          <li v-for="(item,index) in vendorData.base.qualifications" :key="index">{{item.name}}</li>
        </ul>
        <div :class="$style['upload-tips-text']"  class="gray-color">* 建议分辨率：120dpi，图片格式：.jpg、.png，可上传多张图片；</div>
      </pt-form-item>
      <pt-form-item label="代售合同：" :labelWidth="labelWidth">
        <!-- <wt-upload-file :action="uploadApi" :data="picture_params" :img-url="privateResourcesUrl" listType="text"
          v-model="vendorData.base.contracts" :class="$style['dialog-upload']">
          <el-button size="small" type="primary">点击上传</el-button>
        </wt-upload-file> -->
        <wt-upload-big-file v-model="vendorData.base.contracts"  @getStatus="getStatus"></wt-upload-big-file>
      </pt-form-item>
      <pt-sub-title title="供应商开票信息"></pt-sub-title>
      <pt-form-item label="发票类型：" :labelWidth="labelWidth" :required="true">
        <el-radio-group name="invoice.type" data-vv-as="发票类型" v-validate="'required'" v-model="vendorData.invoice.type">
          <el-radio label="SPECIAL_VAT">增值税专用发票</el-radio>
          <el-radio label="ORDINARY_VAT">增值税普通发票</el-radio>
        </el-radio-group>
      </pt-form-item>
      <pt-form-item label="可开具发票类型：" :labelWidth="labelWidth" :required="true">
        <el-checkbox-group name="invoiceProvides" data-vv-as="开具发票类型" v-validate="'required'" v-model="vendorData.invoiceProvides">
          <el-checkbox label="ELECTRONIC">电子发票</el-checkbox>
          <el-checkbox label="PAPER">纸质发票</el-checkbox>
        </el-checkbox-group>
        <!-- <wt-checkbox :checkList="invoiceProvideList" labelName="invoiceProvides" name="invoiceProvides" data-vv-as="开具发票类型" v-validate="'required'" v-model="vendorData.invoiceProvides" style="line-height:40px"></wt-checkbox> -->
      </pt-form-item>
      <pt-form-item label="发票抬头：" :labelWidth="labelWidth" :required="true">
        <el-input name="invoice.title" data-vv-as="发票抬头" v-validate="'required'" v-model="vendorData.invoice.title" placeholder="请输入发票抬头"></el-input>
      </pt-form-item>
      <pt-form-item label="纳税人识别号：" :labelWidth="labelWidth">
        <el-input v-model="vendorData.invoice.taxId" placeholder="请输入纳税人识别号"></el-input>
      </pt-form-item>
      <pt-form-item label="公司地址：" :labelWidth="labelWidth" :required="true">
        <el-input name="invoice.companyAddress" data-vv-as="公司地址" v-validate="'required'" v-model="vendorData.invoice.companyAddress" placeholder="请输入公司地址"></el-input>
      </pt-form-item>
      <pt-form-item label="公司电话：" :labelWidth="labelWidth" :required="true">
        <el-input name="invoice.companyTel" data-vv-as="公司电话" v-validate="'required'" v-model="vendorData.invoice.companyTel" placeholder="请输入公司电话"></el-input>
      </pt-form-item>
      <pt-form-item label="开户银行：" :labelWidth="labelWidth">
        <el-input v-model="vendorData.invoice.depositBank" placeholder="请输入开户银行"></el-input>
      </pt-form-item>
      <pt-form-item label="银行账户：" :labelWidth="labelWidth">
        <el-input v-model="vendorData.invoice.depositBankAccount" placeholder="请输入银行账户"></el-input>
      </pt-form-item>
      <pt-sub-title title="微信支付"></pt-sub-title>
      <pt-form-item label="微信支付特约商户号：" :labelWidth="labelWidth">
        <el-input  v-model="vendorData.subMchId" placeholder="请输入微信支付特约商户号"></el-input>
      </pt-form-item>
      <!-- <pt-sub-title title="第三方商品政策"></pt-sub-title>
      <pt-form-item label="售后政策：" :labelWidth="labelWidth">
        <el-input  v-model="vendorData.policy.name" placeholder="请输入售后政策"></el-input>
      </pt-form-item>
      <pt-form-item label="说明：" :labelWidth="labelWidth">
        <el-input type="textarea" :autosize="{ minRows: 5, maxRows: 6 }" v-model="vendorData.policy.content" placeholder="请输入售后政策说明"></el-input>
      </pt-form-item> -->
      <picture-dialog :showDialog="showDialog" @getFile="getFile" @updateVisible="updateVisible" :uploadApi="uploadApi" :picture-params="picture_params"></picture-dialog>
  </div>
</template>

<script>
import pictureDialog from './picture-dialog'
import formMixins from 'mixins/form'
import { vendorsType } from 'json/mall-options'
import wtUploadBigFile from './wt-upload-big-file'
import vendorTypeSelector from './vendor-type-selector'
// 组件class前缀
const prefixCls = 'pt-third-vendor-form'

export default {
  name: 'pt-third-vendor-form',
  mixins: [formMixins],
  computed: {
    classes () {
      return `${prefixCls}`
    },
    vendorsTypes () {
      return vendorsType
    }
  },
  props: {
    value: {
      type: Object,
      default: () => {}
    }
  },
  components: { pictureDialog, wtUploadBigFile, vendorTypeSelector },
  data () {
    return {
      vendorData: this.value ? this.value : {
        // 基本信息
        base: {
          qualifications: [],
          contracts: [],
          licenses: []
        },
        // 发票
        invoice: {
          type: 'SPECIAL_VAT'
        },
        // 售后政策
        policy: {}
      },
      labelWidth: '150px',
      uploadApi: this.$uploadApi,
      picture_params: {
        resourceName: 'organization'
      },
      privateResourcesUrl: this.$privateResourcesUrl,
      showDialog: false
    }
  },
  watch: {
    vendorData: {
      handler (val) {
        console.log('val', val)
        this.$emit('input', val)
      },
      deep: true
    },
    value (val) {
      this.vendorData = val
    }
  },
  methods: {
    updateVisible (val) {
      this.showDialog = val
    },
    getFile (val) {
      console.log('val', val)
      this.vendorData.base.qualifications.push(val)
    },
    getStatus (val) {
      this.$emit('isUpload', val)
    }
  }
}
</script>

<style module lang="less">
/* 已启用css module， template中请使用$style.className添加class */
/* 务必遵循css BEM原则 */
.pt-third-vendor-form{
  :global{
      .el-input,.el-input__inner{
        max-width: 2.8rem;
      }
      .el-input--suffix .el-input__inner{
        min-width: 2.8rem;
      }
      .el-upload--picture-card,.el-upload-list--picture-card .el-upload-list__item{
        width:204px;
        height: 128px;
      }
      el-textarea,.el-textarea__inner{
        width:500px;
      }
      .wt-upload-file{
        line-height: 0;
        margin-top: 10px;
      }
      .el-upload-list{
        max-width: 800px;
      }
  }
  .pictureNames{
    display: flex;
    margin:0;
    padding-left: 0;
    li{
      width:204px;
      line-height: 20px;
      text-align: center;
    }
  }
  .upload-file-text{
    line-height: 128px;
  }

}

.third-vendor-basic-messgae{

}
</style>
